import React from 'react';
import { Modal, makeStyles, Theme, createStyles, Backdrop, Fade } from '@material-ui/core';

import { useCancelRoute } from 'hooks';
import { EditWardProps } from '../EditWardPage/types';
import { WardDeactivationForm } from './WardDeactivationForm';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    form: {
      backgroundColor: theme.palette.background.paper,
      border: '0px',
      borderRadius: '2px',
      boxShadow: theme.shadows[5],
    },
  })
);

export const WardDeactivationPage = ({ ward }: EditWardProps) => {
  const classes = useStyles();

  const { onCancel } = useCancelRoute(`/wards/manage/${ward.id}/edit`);

  return (
    <Modal
      open={true}
      onClose={onCancel}
      aria-labelledby="Деактивация подопечного"
      aria-describedby="Используйте эту форму для ввода данных деактивации подопечного"
      className={classes.modal}
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={true}>
        <div className={classes.form}>
          <WardDeactivationForm ward={ward} onClose={onCancel} />
        </div>
      </Fade>
    </Modal>
  );
};
